import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import BusinessProfileModal from "../employeeInfo/businessProfileModal";
import { useState } from "react";
import ElegentProfileModal from "../employeeInfo/ElegentPrimeProfileModal";

export const ShareMessageContainer = () => {
  const navigate = useNavigate();
const [open,setOpen]=useState(false)
const [openT,setOpenT]=useState(false)
  return (
    <Grid 
    mt={4}
      container 
      spacing={2} 
      sx={{ p: "10px"}} // Center align buttons
    >
      {[
        { label: "Share Message", onClick: () => navigate(routePath.SHARESESSAGE) },
        { label: "Share Rate Card", onClick: () => navigate(routePath.SHARERATECARD) },
        { label: "Share Business Profile", onClick: () => {setOpen(true)} },
        { label: "Share Employee Profile", onClick: () => {navigate(routePath.SHAREMESSAGEPROFILE)} },
        { label: "Share Elegent Prime Profile", onClick: () => {setOpenT(true)} },
      ].map((item, index) => (
        <Grid item xs={12} sm={4} key={index}> {/* 3 buttons per row */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              height: "50px", // Fixed height
              width: "100%", // Full width of Grid item
              fontSize: "16px",
            //   fontWeight: "bold",
            //   borderRadius: "8px",
              textTransform: "none",
              backgroundColor: "#bb4a9b",
              transition: "0.3s",
              "&:hover": { backgroundColor: "#3695b6" },
              "&:active": { transform: "scale(0.95)" },
            }}
            onClick={item.onClick}
          >
            {item.label}
          </Button>
        </Grid>
      ))}
      <BusinessProfileModal open={open} setOpen={setOpen} />
      <ElegentProfileModal open={openT} setOpen={setOpenT} />
    </Grid>
  );
};
